import React from 'react';

const ROWS = [
  { label: '販売業者', value: '株式会社木村技研' },
  { label: '代表者名', value: '木村剛' },
  { label: '所在地', value: '東京都新宿区西落合三丁目8番5-201号' },
  { label: '電話番号', value: '電話番号はご請求により遅滞なく開示いたします（お問い合わせフォームよりご連絡ください）' },
  { label: 'メールアドレス', value: 'k.tsuyoshi@kimura-giken.net' },
  { label: 'サービスURL', value: 'https://nanikiru.net' },
  { label: '販売価格', value: '各プランページに表示の価格（税込）' },
  { label: '支払方法', value: 'クレジットカード（Visa / Mastercard / JCB / American Express）' },
  { label: '支払時期', value: '申込時に即時決済。以降は毎月同日に自動更新' },
  { label: 'サービス提供時期', value: '決済完了後、即時ご利用いただけます' },
  { label: '返品・キャンセル', value: 'デジタルコンテンツの性質上、原則として返金はお受けできません。サブスクリプションはいつでも解約でき、解約後も期間終了まで引き続きご利用いただけます。' },
];

export default function LegalPage() {
  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">特定商取引法に基づく表記</h1>
      <div className="border rounded-xl overflow-hidden">
        {ROWS.map(({ label, value }, i) => (
          <div
            key={label}
            className={`flex flex-col sm:flex-row ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
          >
            <dt className="w-full sm:w-48 shrink-0 px-4 py-3 text-sm font-medium text-gray-600 border-b sm:border-b-0 sm:border-r">
              {label}
            </dt>
            <dd className="px-4 py-3 text-sm text-gray-800 border-b last:border-b-0">
              {value}
            </dd>
          </div>
        ))}
      </div>
    </div>
  );
}
